
window.onload = function () {
  // Extend Moment.js with workday calculation functionality
  initMomentExtensions();
  
  // DOM elements
  const elements = {
    modal: document.getElementById("dateModal"),
    zipButton: document.getElementById("zipButton"),
    zipInput: document.getElementById("zipInput"),
    dateBtn: document.getElementById("dateBtn"),
    checkoutBtn: document.getElementById("checkouttest"),
    closeBtn: document.getElementsByClassName("close")[0],
    notesField: document.querySelector("#note")
  };
  
  // Configuration
  const config = {
    cacheExpiryHours: 0.5,
    apiEndpoint: "/apps/getAvailabilityDates",
    shopDomain: "islandcreekoysters.myshopify.com",
    timezone: "Est",
    cutoffHour: 15, // 3 PM cutoff for next-day delivery
    spinnerDelay: 1000
  };
  
  // Global state
  let calendar;
  
  // Attach event listeners
  setupEventListeners(elements, config);
  
  // Handle outside modal clicks
  window.onclick = function (event) {
    if (event.target == elements.modal) {
      elements.modal.style.display = "none";
      hideSpinner();
    }
  };
};

/**
 * Initialize Moment.js extensions for workday calculations
 */
function initMomentExtensions() {
  moment.fn.addWorkdays = function (days) {
    // Determine positive or negative increment
    const increment = days / Math.abs(days);
    
    // Add full weeks
    let date = this.clone().add(Math.floor(Math.abs(days) / 5) * 7 * increment, 'days');
    
    // Account for weekends
    if (date.isoWeekday() === 6) {
      date.add(-increment, 'days');
    } else if (date.isoWeekday() === 7) {
      date.add(-2 * increment, 'days');
    }
    
    // Add remaining days, skipping weekends
    let remaining = days % 5;
    while (remaining !== 0) {
      date.add(increment, 'days');
      if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
        remaining -= increment;
      }
    }
    
    return date;
  };
}

/**
 * Set up all event listeners
 */
function setupEventListeners(elements, config) {
  // Prevent form submission on mobile keyboards
  $("input").keypress(function(e) {
    const code = e.keyCode ? e.keyCode : e.which;
    if (code === 13 || code === 10) {
      $(this).blur();
      return false;
    }
  });
  
  // Gear Products
  if (elements.checkoutBtn) {
    $(elements.checkoutBtn).on('click', function(event) {
      event.preventDefault();
      loadSpinner();
      handleCheckout(config);
    });
  }
  
  // Seafood Products 
  if (elements.dateBtn) {
    $(elements.dateBtn).on('click', function() {
      checkAndResetCache(config);
      startDeliveryDateFlow(config);
    });
  }
  
  // Setup modal close button
  if (elements.closeBtn) {
    $(".closepopup").on("click", function(e) {
      e.preventDefault();
      elements.modal.style.display = "none";
      hideSpinner();
    });
  }
}

/**
 * Handle checkout process for Gear products
 */
function handleCheckout(config) {
  try {
    // Get current time in specified timezone
    const currentDate = moment().tz(config.timezone).format("YYYY-MM-DD HH:mm:ss.SSS");
    const currentHour = new Date(currentDate).getHours();
    
    // Determine ship date based on time of day
    const today = moment();
    const shipdate = currentHour >= config.cutoffHour 
      ? today.addWorkdays(2).toISOString()
      : today.addWorkdays(1).toISOString();

    // Get available dates from API
    fetchGearDates(shipdate, config);
  } catch (err) {
    completeCheckout();
  }
}

/**
 * Fetch available dates for Gear products
 */
function fetchGearDates(defaultShipdate, config) {
  $.ajax({
    type: "GET",
    url: config.apiEndpoint,
    dataType: "json",
    success: function(json) {
      console.log("json data date",json.data.date);
      if (json.data && json.data.date) {
        console.log("date selected from api",json.data.date);
        const deliverydate_ISO_format = new Date(json.data.date).toISOString();
        setGearDate(deliverydate_ISO_format);
      } else {
        console.log("date selected from fallback",defaultShipdate);
        setGearDate(defaultShipdate);
      }
    },
    error: function(xhr, status, err) {
      setGearDate(defaultShipdate);
    }
  });
}

/**
 * Update cart with gear delivery date and proceed to checkout
 */
function setGearDate(shipdate) {
  $.ajax({
    type: "get",
    url: "/cart.js",
    dataType: "json"
  }).then(function(resData) {
    const items = resData.items;
    let updateData = null;
    
    // Find Gear product and prepare update data
    for (const [index, item] of items.entries()) {
      if (item.product_type === "Gear") {
        updateData = {
          line: index + 1,
          quantity: item.quantity,
          properties: {
            _delivery_date_gear: shipdate
          }
        };
        break;
      }
    }
    
    if (updateData) {
      // Update cart with delivery date
      $.ajax({
        type: "post",
        url: "/cart/change.js",
        data: updateData,
        dataType: "json",
        success: function(response) {
          //loadSpinner();
          setTimeout(completeCheckout, 1000);
        },
        error: function(xhr, status, error) {
          completeCheckout();
        }
      });
    } else {
      // No Gear product in cart
      completeCheckout();
    }
  }).catch(function(error) {
    console.error("Error getting cart:", error);
    completeCheckout();
  });
}

/**
 * Complete checkout process with notes
 */
function completeCheckout() {
  try {
    const notes = document.querySelector("#note")?.value;
    
    if (notes) {
      $.post("/cart/update.js", {
        note: notes
      })
      .then(function() {
        window.location.href = "/checkout";
      })
      .catch(function(error) {
        console.error("Error adding note:", error);
        window.location.href = "/checkout";
      });
    } else {
      window.location.href = "/checkout";
    }
  } catch (error) {
    console.error("Checkout error:", error);
    window.location.href = "/checkout";
  }
}

/**
 * Show loading spinner
 */
function loadSpinner() {
  const node = document.getElementById("content_wrapper");
  if (node) {
    node.insertAdjacentHTML(
      "afterbegin",
      '<div class="spinner-modal"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>'
    );
  }
}

/**
 * Hide loading spinner
 */
function hideSpinner() {
  $(".spinner-modal").hide();
}

/**
 * Check and reset cache if needed
 */
function checkAndResetCache(config) {
  const now = new Date().getTime();
  const setupTime = localStorage.getItem("setupTime");
  
  if (!setupTime) {
    localStorage.setItem("setupTime", now);
  } else {
    const expiryTime = config.cacheExpiryHours * 60 * 60 * 1000;
    if (now - parseInt(setupTime) > expiryTime) {
      localStorage.setItem("setupTime", now);
      // Additional cache clearing logic could go here
    }
  }
}

/**
 * Start delivery date selection flow
 */
function startDeliveryDateFlow(config) {
  loadSpinner();
  
  // Get current cart contents
  $.getJSON("/cart.js", function(cart) {
    // Prepare request to get availability dates
    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      },
      body: JSON.stringify(cart.items)
    };
    
    // Get availability dates from API
    const url = config.apiEndpoint + "?shop=" + config.shopDomain;
    fetch(url, postOptions)
      .then(response => response.json())
      .then(handleAvailabilityResponse)
      .catch(handleApiError);
  });
}

/**
 * Handle the availability API response
 */
function handleAvailabilityResponse(res) {
  if (!res || !res.data) {
    throw new Error("Invalid API response");
  }
  console.log(res);
  const resultArrayCopy = arrayClone(res.data.result.enabled);
  const dateRange = parseDateRange(res.data.result.enabled);
  
  // Check if there are restricted products
  if (res.data.result.limited_product || res.data.result.enabled.length === 0) {
    showModal();
  } else {
    openCalendar(resultArrayCopy);
  }
}

/**
 * Handle API errors
 */
function handleApiError(error) {
  hideSpinner();
  $("#errorModal").show();
  $("#errorModal .closepopup").off("click").on("click", function(e) {
      e.preventDefault();
      $("#errorModal").hide();
      hideSpinner();
  });
}

/**
 * Show the modal with optional message
 */
function showModal() {
  const modal = document.getElementById("dateModal");
  if (modal && modal.style) {
    modal.style.display = "block";
    
    $(".closepopup").off("click").on("click", function(e) {
      e.preventDefault();
      modal.style.display = "none";
      hideSpinner();
    });
  }
}

/**
 * Open the calendar for date selection
 */
function openCalendar(availableDates) {
  let momentArray = parse2DArrayToMomentArray(availableDates);
  let momentHolidays = [
    moment("2019-11-28", "YYYY-MM-DD"), // Thanksgiving 2019
    moment("2019-12-24", "YYYY-MM-DD"), // X-mas eve 2019
    moment("2019-12-25", "YYYY-MM-DD"), // X-mas 2019
    moment("2019-12-31", "YYYY-MM-DD"), // New Years Eve 2019
    moment("2020-01-01", "YYYY-MM-DD")  // New Years Day 2020
  ];
  
  // Create and show calendar
  calendar = new mdDateTimePicker.default({
    type: "date",
    includeDays: momentArray,
    modal: "dp-wrap"
  });
  
  hideSpinner();
  calendar.toggle();
  
  // Set up calendar events
  setupCalendarEvents(calendar);
}

/**
 * Setup calendar selection events
 */
function setupCalendarEvents(calendar) {
  const triggerDiv = document.createElement("div");
  calendar.trigger = triggerDiv;
  
  triggerDiv.addEventListener("onOk", function() {
    const selectedDate = calendar.time;
    handleDateSelection(selectedDate);
  });
}

/**
 * Handle date selection from calendar
 */
function handleDateSelection(selectedDate) {
  console.log("Selected date:", selectedDate.format("MM-DD-YYYY"));
  
  // Format as ISO time
  const localISOTime = new Date(selectedDate).toISOString().slice(0, -1);
  
  // Update cart with delivery date
  loadSpinner();
  updateCartWithDeliveryDate(localISOTime);
}

/**
 * Update cart items with delivery date
 */
function updateCartWithDeliveryDate(localISOTime) {
  try {
    $.ajax({
      type: "get",
      url: "/cart.js",
      dataType: "json"
    }).then(function(cartData) {
      const items = cartData.items;
      const updatedItems = prepareItemsWithDeliveryDate(items, localISOTime);
      
      // Clear cart and add updated items
      clearAndUpdateCart(updatedItems);
    });
  } catch (err) {
    console.error("Error updating cart:", err);
    completeCheckout();
  }
}

/**
 * Prepare cart items with delivery date
 */
function prepareItemsWithDeliveryDate(items, localISOTime) {
  const keysToKeep = ["quantity", "id", "product_type"];
  
  // Filter and prepare items
  const preparedItems = items.map(function(item) {
    return Object.assign(
      {},
      ...keysToKeep.map(key => ({ [key]: item[key] }))
    );
  });
  
  // Add delivery date to non-Gear items
  for (let i = 0; i < preparedItems.length; i++) {
    if (preparedItems[i].product_type !== "Gear") {
      preparedItems[i] = {
        id: items[i].id,
        quantity: items[i].quantity,
        properties: {
          'Expected Delivery Date': moment(localISOTime).format('MM-DD-YYYY'),
          _delivery_date: localISOTime,
        }
      };
      break; // Only add to the first non-Gear item
    }
  }
  
  return preparedItems;
}

/**
 * Clear cart and add updated items
 */
function clearAndUpdateCart(items) {
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    success: function() {
      // Add updated items back to cart
      $.post("/cart/add.js", {
        items: items,
      }).then(function() {
        setTimeout(completeCheckout, 1000);
      }).catch(function(error) {
        console.error("Error adding items back to cart:", error);
        completeCheckout();
      });
    },
    error: function(error) {
      console.error("Error clearing cart:", error);
      completeCheckout();
    }
  });
}

/**
 * Parse date range from 2D array
 */
function parseDateRange(input2DArray) {
  if (!input2DArray || !input2DArray.length) {
    return { first: null, last: null };
  }
  
  //get the first and last value of the array
  let firstA = [...input2DArray[0]];
  let lastA = [...input2DArray[input2DArray.length - 1]];
  
  //because month values start at 0
  firstA[1]++;
  lastA[1]++;
  
  //assumes moment.js is loaded
  let first = moment(firstA.join("-"), "YYYY-MM-DD");
  let last = moment(lastA.join("-"), "YYYY-MM-DD");
  
  return { first, last };
}

/**
 * Parse 2D array to moment array
 */
function parse2DArrayToMomentArray(input2DArray) {
  if (!input2DArray) return [];
  
  let returnArray = [];
  for (let i = 0; i < input2DArray.length; i++) {
    let dateParts = [...input2DArray[i]];
    dateParts[1]++;
    let d = moment(dateParts.join("-"), "YYYY-MM-DD");
    returnArray.push(d);
  }
  return returnArray;
}

/**
 * Deep clone array
 */
function arrayClone(arr) {
  if (!arr) return null;
  
  if (Array.isArray(arr)) {
    const copy = arr.slice(0);
    for (let i = 0; i < copy.length; i++) {
      copy[i] = arrayClone(copy[i]);
    }
    return copy;
  } else if (typeof arr === "object") {
    throw "Cannot clone array containing an object!";
  } else {
    return arr;
  }
}